module.exports = __webpack_public_path__ + "media/conmex/calculator-a53dc063.png";